import { useEffect } from "react";
import Nav from "../components/Nav";import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import HowItWorks from "../components/HowItWorks";
import Collections from "../components/Collections";
import WhyUs from "../components/WhyUs";
import Estimator from "../components/Estimator";
import Booking from "../components/Booking";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";
import { ContentProvider, useContent } from "../lib/content";
import { scrollToId } from "../lib/site";

function SeoManager() {
  const { seo } = useContent();
  useEffect(() => {
    if (!seo?.meta_title) return;
    document.title = seo.meta_title;
    const setMeta = (key, content, isProp = false) => {
      if (!content) return;
      const attr = isProp ? "property" : "name";
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", seo.meta_description);
    setMeta("keywords", seo.meta_keywords);
    setMeta("og:title", seo.meta_title, true);
    setMeta("og:description", seo.meta_description, true);
    setMeta("og:image", seo.og_image, true);
    setMeta("twitter:title", seo.meta_title);
    setMeta("twitter:description", seo.meta_description);
  }, [seo]);
  return null;
}

export default function Home() {
  useEffect(() => {
    const id = window.location.hash.replace("#", "");
    if (!id) return;
    const t = setTimeout(() => scrollToId(id), 350);
    return () => clearTimeout(t);
  }, []);

  return (
    <ContentProvider>
      <main data-testid="home-page">
        <SeoManager />
        <Nav />
        <Hero />
        <Marquee />
        <HowItWorks />
        <Collections />
        <WhyUs />
        <Estimator />
        <Booking />
        <Testimonials />
        <FAQ />
        <Footer />
        <WhatsAppFloat />
      </main>
    </ContentProvider>
  );
}
